import React from 'react';

import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { createRoot } from 'react-dom/client';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/store';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Switch>
        <Route path="/client-deliverable" component={App} />
        {/* <Route path="/client-deliverable/provider_preview" component={App} /> */}
        <Route path="/" component={App} />
      </Switch>
    </Provider>
  </BrowserRouter>,
);

reportWebVitals();
